import { render } from "./permissionrole.vue?vue&type=template&id=99c48878&scoped=true"
import script from "./permissionrole.vue?vue&type=script&lang=js"
export * from "./permissionrole.vue?vue&type=script&lang=js"

import "./permissionrole.vue?vue&type=style&index=0&id=99c48878&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99c48878"]])

export default __exports__